import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import DeleteTicketButton from 'src/components/Control/Buttons/DeleteTicketButton';
import AddTicketButton from 'src/components/Control/Buttons/AddTicketButton';
import SendTicketButton from 'src/components/Control/Buttons/SendTicketButton';
import DownloadTicketButton from 'src/components/Control/Buttons/DownloadTicketButton';
import ExportTicketButton from 'src/components/Control/Buttons/ExportTicketButton';

const getFundraisingId = () => {
  const pathSegments = window.location.pathname.split('/');
  const last = pathSegments[pathSegments.length - 1];
  const id = parseInt(last, 10);
  return Number.isNaN(id) ? undefined : id;
};

const TicketToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.tickets] || [],
  );

  return (
    <>
      <AddTicketButton eventId={getFundraisingId()} />
      <DeleteTicketButton disabled={!selections.length} />
      <ConfigureColumnsButton entity={ENTITIES.tickets} />
      <UnselectAllMenubutton
        entity={ENTITIES.tickets}
        disabled={!selections.length} />
      <SendTicketButton eventId={getFundraisingId()} />
      <DownloadTicketButton eventId={getFundraisingId()} />
      <ExportTicketButton eventId={getFundraisingId()} />
    </>
  );
};

export default TicketToolbar;
